import moduleUserState from "./moduleUserState"
import moduleUserGetters from "./moduleUserGetters"
import moduleUserMutations from "./moduleUserMutations"
import moduleUserActions from "./moduleUserActions"
import client from "./client/index";


export default {
    namespaced: true,
    state: moduleUserState,
    mutations: moduleUserMutations,
    actions: moduleUserActions,
    getters: moduleUserGetters,
    modules: {
        client: client
    },
}
